import { all, call, fork, put, select, take } from 'redux-saga/effects';

import { UPDATE_HIGHLIGHT } from './actions';
import { RESET_ANNOTATION } from 'Reducers/compModels';
import { SAVE_HIGHLIGHTS, SAVE_NOTES } from 'Reducers/dataModels';

import { highlightsAndNotes as nmHighlightsAndNotes } from 'Lib/normalizers';
import notebookFilterMarkers from 'Lib/notebookFilterMarkers';
import { updateHighlight as vsUpdateHighlight } from 'Services/learnkit';


function* update() {
  while (true) {
    const { data:{ markerId, selectedHighlight } } = yield take(UPDATE_HIGHLIGHT);

    const { id, noteText } = selectedHighlight;

    const { highlights, notes } = yield select(state => {
      return {
        highlights: state.highlights,
        notes: state.notes
      };
    });

    const { highlight:vsHighlight } = yield call(vsUpdateHighlight, id, markerId, noteText);
    const [newHighlight, newNote] = yield nmHighlightsAndNotes([vsHighlight]);

    const highlightsWithoutUpdatedHighlight = highlights.filter(highlight => {
      return highlight.id !== newHighlight[0].id;
    });

    const notesWithoutUpdatedNotes = notes.filter(note => {
      return note.id !== newHighlight[0].id;
    });

    const updatedHighlights = [...highlightsWithoutUpdatedHighlight, ...newHighlight];
    const updatedNotes = [...notesWithoutUpdatedNotes, ...newNote];

    yield fork(notebookFilterMarkers, updatedHighlights);

    yield all([
      put({ type: RESET_ANNOTATION }),
      put({ type: SAVE_HIGHLIGHTS, data: updatedHighlights }),
      put({ type: SAVE_NOTES, data: updatedNotes })
    ]);
  }
}


export default update;
